const initWideGallerySlider = () => {
    const gallerySliderArray = document.querySelectorAll('.wide-gallery-widget .slider');
    if (gallerySliderArray)
        gallerySliderArray.forEach(slider => {
            if (slider.querySelectorAll(".slide").length > 1) {
                new Flickity(slider, {
                    // options
                    cellAlign: 'left',
                    contain: true,
                    autoPlay: 3000,
                    pageDots: true,
                    prevNextButtons: false
                });
            }
        });
};
